import { useQuery } from "@tanstack/react-query";
import type { SellerOrdersStatisticsParams } from "./statisticsApi";
import { getSellerOrdersStatistics } from "./statisticsApi";

export function useSellerOrdersStatistics(
  sellerIds: string[],
  params: Omit<SellerOrdersStatisticsParams, "sellerIds">,
) {
  const fullParams: SellerOrdersStatisticsParams = {
    ...params,
    sellerIds: sellerIds.length === 0 ? "all" : sellerIds,
  };
  return useQuery({
    queryKey: ["admin", "statistics", "sellers", "orders", fullParams],
    queryFn: ({ signal }) => getSellerOrdersStatistics(fullParams, signal),
    enabled: sellerIds.length > 0 && Boolean(params.from),
  });
}
